<template>
  <div id="app">
    <div class="off-canvas position-left" id="offCanvas" data-off-canvas>
      <!-- Close button -->
      <button
        class="close-button"
        aria-label="Close menu"
        type="button"
        data-close
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <!-- Menu -->
      <ul class="vertical menu">
        <li><a href="#">Foundation</a></li>
        <li><a href="#">Dot</a></li>
        <li><a href="#">ZURB</a></li>
        <li><a href="#">Com</a></li>
        <li><a href="#">Slash</a></li>
        <li><a href="#">Sites</a></li>
      </ul>
    </div>

    <div class="off-canvas-content" data-off-canvas-content>
      
        <div class="">
            <app-header style="position: -webkit-sticky;position: sticky; top: 0px; z-index: 999;" />
            <app-sub-header />
            <main>
                <router-view :key="$route.fullPath"/>
            </main>
            <app-footer/>
        </div>
      


    </div>
  </div>
</template>

<script>

//import Foundation from 'foundation-sites'
import "script-loader!jquery/dist/jquery.min";
import "script-loader!what-input/dist/what-input.min";
import "script-loader!foundation-sites/dist/js/foundation.min";

export default {
  name: "App",
  components: {
    'app-header': () => import ('./app/components/app-header'),
    'app-sub-header': () => import ('./app/components/app-sub-header'),
    'app-footer': () => import ('./app/components/app-footer')
  },
  mixins: [require("./app/mixins/foundation")],
  computed: {
    display404(){
        return this.$root.display404 === true ?'pageNotFound':'';
    }
  },
};
</script>

<style >
</style>
